import dayjs from 'dayjs'
import { MonthlyProgressItem } from 'types'

export const getProgressValue = (type: 'SEO' | 'DMS' | 'AM' | 'OVERALL', progressData: MonthlyProgressItem[]) => {
  const thisMonth = dayjs().format('YYYY-MM')
  const item = progressData?.find(p => p.month === thisMonth)
  if (!item) return 0

  if (type === 'SEO') return item.seoProgress || 0
  if (type === 'DMS') return item.dmsProgress || 0
  if (type === 'AM') return item.amProgress || 0
  if (type === 'OVERALL') return item.overallProgress || 0
  return 0
}
